import React from 'react';
import { Box, Theme, withStyles } from '@material-ui/core';

export const ReportCashflowSummaryContainer = withStyles((theme: Theme) => ({
  root: {
    display: 'flex',
    width: '100%',
    flexWrap: 'wrap',
    [theme.breakpoints.up('md')]: {
      justifyContent: 'space-between',
    },
  },
}))((props) => <Box {...props} />);

export default ReportCashflowSummaryContainer;
